import { BADGES } from '../hooks/useStreak';

const DEFAULT_THEME = {
  bg1: '#f9fafb',
  bg2: '#f3f4f6',
  border: '#d1d5db',
  text: '#374151',
  shadow: 'rgba(17, 24, 39, 0.08)',
  shine: 'rgba(255, 255, 255, 0.35)',
  hoverShadow: 'rgba(17, 24, 39, 0.12)',
};

export default function StreakBadge({ currentStreak, onClick }) {

const currentBadge = [...BADGES].reverse().find((badge) => currentStreak >= badge.days) || BADGES[0];

  const theme = currentBadge?.theme || DEFAULT_THEME;

  return (
    <>
      <button
        type="button"
        className="streak-badge"
        onClick={onClick}
        aria-label={`Série de ${currentStreak} jour${currentStreak > 1 ? 's' : ''}`}
        style={{
          '--bg1': theme.bg1,
          '--bg2': theme.bg2,
          '--bg3': theme.bg3 || theme.bg2,
          '--border': theme.border,
          '--text': theme.text,
          '--shadow': theme.shadow,
          '--shine': theme.shine,
          '--hoverShadow': theme.hoverShadow,
        }}
      >
        <span className="streak-badge-content">
          <span className="streak-emoji" aria-hidden="true">
            {currentBadge?.emoji || '🌱'}
          </span>
          <span className="streak-count">{currentStreak}</span>
        </span>
      </button>

      <style>{`
.streak-badge {
  height: var(--tb-badge-h, 30px);
  min-height: var(--tb-badge-h, 30px);
  max-height: var(--tb-badge-h, 30px);

  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0 var(--tb-badge-px, 12px);
  box-sizing: border-box;

  font-size: var(--tb-badge-font, 13px);
  line-height: 1;

  border-radius: 9999px;
  background: linear-gradient(
    135deg,
    var(--bg1) 0%,
    var(--bg2) 60%,
    var(--bg3) 100%
  );
  border: 1.5px solid var(--border);
  box-shadow: 0 2px 8px var(--shadow);
  color: var(--text);

  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
  flex-shrink: 0;

  position: relative;
  overflow: hidden;
  vertical-align: middle;
}

.streak-badge-content {
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--tb-badge-gap, 6px);
  line-height: 1;
  transform: none;
}

        .streak-badge::before {
          content: '';
          position: absolute;
          inset: 0;
          transform: translateX(-120%);
          background: linear-gradient(
            90deg,
            transparent,
            var(--shine),
            transparent
          );
          transition: transform 0.5s ease;
          pointer-events: none;
        }

        .streak-badge:hover {
          transform: translateY(-1px) scale(1.03);
          box-shadow: 0 4px 12px var(--hoverShadow);
          border-color: var(--border);
        }

        .streak-badge:hover::before {
          transform: translateX(120%);
        }

        .streak-badge:active {
          transform: translateY(0) scale(0.98);
        }

.streak-emoji {
  width: var(--tb-badge-emoji, 16px);
  font-size: var(--tb-badge-emoji, 16px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  flex: 0 0 auto;
  transform: translateY(var(--tb-badge-emoji-shift, 0px));
  font-family: "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif;
}

.streak-count {
  height: 100%;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-family: var(--font-sans);
  font-weight: 800;
  font-size: var(--tb-badge-font, 13px);
  line-height: 1;
  color: var(--text);
  font-variant-numeric: tabular-nums;

  margin: 0;
  padding: 0;
  transform: none;
}
      `}</style>
    </>
  );
}